import { PureComponent } from 'react';

import withSettings, { IWithSettingsProps } from './withSettings';
import {
  SettingsPubSubEvent,
  ISettingsEvents,
} from '@wix/podcasts-common/dist/settings';

interface IOnSettingsEventProps extends IWithSettingsProps {
  event: SettingsPubSubEvent;
  onEvent: (eventData: any) => void;
}

function isSettingsEventPublished(
  event: SettingsPubSubEvent,
  events: ISettingsEvents,
  prevEvents: ISettingsEvents,
) {
  const eventInfo = events && events[event];
  const prevEventInfo = prevEvents && prevEvents[event];

  return (
    !!eventInfo &&
    (!prevEventInfo || eventInfo.version !== prevEventInfo.version)
  );
}

class SettingsEventListener extends PureComponent<IOnSettingsEventProps> {
  checkEvents(events: ISettingsEvents, prevEvents: ISettingsEvents) {
    const { event, onEvent } = this.props;

    if (isSettingsEventPublished(event, events, prevEvents)) {
      onEvent(events[event].data);
    }
  }

  componentDidUpdate(prevProps: IOnSettingsEventProps) {
    this.checkEvents(this.props.settings.events, prevProps.settings.events);
  }

  render() {
    return null;
  }
}

export default withSettings(SettingsEventListener);
